import { render, staticRenderFns } from "./CrimeSummary.vue?vue&type=template&id=3846f408&scoped=true&"
import script from "./CrimeSummary.vue?vue&type=script&lang=js&"
export * from "./CrimeSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3846f408",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3846f408')) {
      api.createRecord('3846f408', component.options)
    } else {
      api.reload('3846f408', component.options)
    }
    module.hot.accept("./CrimeSummary.vue?vue&type=template&id=3846f408&scoped=true&", function () {
      api.rerender('3846f408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/Print/CrimeSummary.vue"
export default component.exports